import { DisposalSet } from '../../../utils';
import { registerFragment } from '../../registry';
import './styles.scss';
const gc = new DisposalSet();
registerFragment('aoc-sticky-side-nav', (fragmentEl, config, meta) => {
  const isEditMode = document.body.classList.contains('has-edit-mode-menu');
  const navMenu = fragmentEl.querySelector('.aoc-toc-menu');
  const navList = fragmentEl.querySelector('.aoc-toc__list');
  const headingButton = fragmentEl.querySelector('.aoc-toc__btn-nav');
  const widgetsMenu = fragmentEl.querySelector('.aoc-toc-sidebar-widgets');

  // Scrapes both top-level sections (H2) and nested sub-sections (H3) across the layout drop zones
  const targetHeadings = fragmentEl.querySelectorAll('h2, h3');

  /*
  * Populate the Table of Contents Links Hierarchy
  */
  if (targetHeadings.length > 0 && navList) {
    let currentParentLi = null;
    let currentSubList = null;
    const setupLinkClick = (link, heading) => {
      link.addEventListener('click', e => {
        e.preventDefault();

        // Clear layout shift on mobile viewports before scroll calculations fire
        if (window.innerWidth < 1024) {
          navList.style.transition = 'none';
          if (widgetsMenu) {
            widgetsMenu.style.transition = 'none';
          }

          // Collapse the main mobile navigation panel panel synchronously
          navList.classList.remove('aoc-toc__list--open');
          headingButton?.classList.remove('aoc-toc__btn--open');
          widgetsMenu?.classList.remove('aoc-toc-sidebar-widgets--open');
          void navList.offsetHeight;
          if (widgetsMenu) {
            void widgetsMenu.offsetHeight;
          }
          heading.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          setTimeout(() => {
            navList.style.transition = '';
            if (widgetsMenu) {
              widgetsMenu.style.transition = '';
            }
          }, 50);
        } else {
          heading.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
        history.pushState(null, '', `#${heading.id}`);
      });
    };
    targetHeadings.forEach((heading, index) => {
      if (!heading.id) {
        const safeText = heading.textContent?.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
        heading.id = safeText ? safeText : `section-${index}`;
      }
      const isSubSection = heading.tagName.toLowerCase() === 'h3';
      if (!isSubSection) {
        // 1. Process Parent Items (H2)
        currentParentLi = document.createElement('li');
        currentParentLi.classList.add('aoc-toc__item');
        const wrapper = document.createElement('div');
        wrapper.classList.add('aoc-toc__parent-wrapper');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        const navLabel = heading.getAttribute('data-nav-label');
        link.textContent = navLabel ? navLabel.trim() : heading.textContent.trim();
        link.classList.add('aoc-toc__link--parent');
        setupLinkClick(link, heading);
        wrapper.appendChild(link);
        currentParentLi.appendChild(wrapper);
        navList.appendChild(currentParentLi);

        // Reset sublist trackers for the new section block
        currentSubList = null;
      } else {
        // 2. Process Nested Subnav Items (H3)
        if (!currentParentLi) {
          currentParentLi = document.createElement('li');
          currentParentLi.classList.add('aoc-toc__item');
          navList.appendChild(currentParentLi);
        }

        // Initialize the sublist tree nodes if this is the first child child encountered
        if (!currentSubList) {
          currentParentLi.classList.add('aoc-toc__item--has-children');
          currentSubList = document.createElement('ul');
          currentSubList.classList.add('aoc-toc__sublist');
          currentParentLi.appendChild(currentSubList);
          const wrapper = currentParentLi.querySelector('.aoc-toc__parent-wrapper');
          if (wrapper) {
            const toggleBtn = document.createElement('button');
            toggleBtn.type = 'button';
            toggleBtn.classList.add('aoc-toc__toggle-subnav');
            toggleBtn.setAttribute('aria-label', 'Toggle sub-navigation section');

            // Icon element utilizing the background CSS target structure
            const toggleIcon = document.createElement('span');
            toggleIcon.classList.add('aoc-toc__toggle-icon');
            toggleBtn.appendChild(toggleIcon);
            const subListRef = currentSubList;
            toggleBtn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              toggleBtn.classList.toggle('aoc-toc__toggle-subnav--open');
              subListRef.classList.toggle('aoc-toc__sublist--open');
            });
            wrapper.appendChild(toggleBtn);
          }
        }
        const subListItem = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        const navLabel = heading.getAttribute('data-nav-label');
        link.textContent = navLabel ? navLabel.trim() : heading.textContent.trim();
        link.classList.add('aoc-toc__link--sub');
        setupLinkClick(link, heading);
        subListItem.appendChild(link);
        currentSubList.appendChild(subListItem);
      }
    });
  } else {
    if (!isEditMode && navMenu) {
      navMenu.style.display = 'none';
    }
  }

  /*
  * Intersection Observer Active Tracker
  */
  if (targetHeadings.length > 0 && navList) {
    const options = {
      root: null,
      rootMargin: "-15% 0px -60% 0px",
      threshold: 0.0
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute("id");
          navList.querySelectorAll('a').forEach(link => link.classList.remove("active"));
          const activeLink = fragmentEl.querySelector(`a[href="#${id}"]`);
          if (activeLink) {
            activeLink.classList.add("active");

            // Auto-expand mobile parent drawers if scrolling sweeps down into an embedded sub-heading
            if (window.innerWidth < 1024 && activeLink.classList.contains('aoc-toc__link--sub')) {
              const parentSublist = activeLink.closest('.aoc-toc__sublist');
              const parentLi = activeLink.closest('.aoc-toc__item--has-children');
              if (parentSublist && !parentSublist.classList.contains('aoc-toc__sublist--open')) {
                parentSublist.classList.add('aoc-toc__sublist--open');
                parentLi?.querySelector('.aoc-toc__toggle-subnav')?.classList.add('aoc-toc__toggle-subnav--open');
              }
            }
          }
        }
      });
    }, options);
    targetHeadings.forEach(targetHeading => observer.observe(targetHeading));
  }

  /*
  * Mobile Accordion Expand/Collapse Action Trigger
  */
  if (navList && headingButton) {
    headingButton.addEventListener('click', e => {
      e.preventDefault();
      if (window.innerWidth < 1024) {
        navList.classList.toggle('aoc-toc__list--open');
        headingButton.classList.toggle('aoc-toc__btn--open');
        widgetsMenu?.classList.toggle('aoc-toc-sidebar-widgets--open');
      }
    });
  }
});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}